import React, { Fragment, useState } from 'react'
import { Controller } from "react-hook-form"
import Proptypes from 'prop-types'
import moment from "moment"
import _ from 'lodash'
//************************************//
import { trans } from '@utils'
//************************************//
import UncontrolledDateRange from "./UncontrolledDateRange"
//************************************//
const DateRange = ({
  name = '',
  control = null,
  defaultValue: defaultValueProp = [],
  ranges = [],
  className = '',
  placeholder = '',
  size = 'md',
  format = 'L',
  displayFormat = 'L',
  minDate = null,
  maxDate = null,
  parentEl = 'body',
  linkedCalendars = true,
  showCustomRangeLabel = true,
  allowClear = false,
  cancelLabel = 'gen.actions.cancel',
  applyLabel = 'gen.actions.apply',
  customRangeLabel = 'gen.dateRange.custom',
  onChange = () => { },
  onClear = () => { }
}) => {
  const [ref, setRef] = useState(null)
  const defaultValue = _.size(defaultValueProp) > 0
    ? _.map(defaultValueProp, date => moment.utc(date).local())
    : null
  //************************************//
  return (
    <Controller
      refs={(ref) => setRef(ref)}
      as={UncontrolledDateRange}
      name={name}
      control={control}
      defaultValue={defaultValue}
      ranges={ranges}
      className={className}
      placeholder={placeholder}
      size={size}
      format={format}
      displayFormat={displayFormat}
      minDate={minDate}
      maxDate={maxDate}
      parentEl={parentEl}
      linkedCalendars={linkedCalendars}
      showCustomRangeLabel={showCustomRangeLabel}
      allowClear={allowClear}
      cancelLabel={trans(cancelLabel)}
      applyLabel={trans(applyLabel)}
      customRangeLabel={trans(customRangeLabel)}
      onFocus={() => {
        // console.log(ref)
        // focus on validation
        // focus and close on validation
      }}
      onInputChange={(value) => {
        onChange(value)
      }}
      onClear={(clearProps) => {
        onClear(clearProps)
      }}
    />
  )
}
//************************************//
DateRange.propTypes = {
  name: Proptypes.string.isRequired,
  control: Proptypes.any,
  defaultValue: Proptypes.array,
  ranges: Proptypes.array,
  className: Proptypes.string,
  placeholder: Proptypes.string,
  size: Proptypes.string,
  format: Proptypes.string,
  displayFormat: Proptypes.string,
  minDate: Proptypes.string,
  maxDate: Proptypes.string,
  parentEl: Proptypes.string,
  linkedCalendars: Proptypes.bool,
  showCustomRangeLabel: Proptypes.bool,
  allowClear: Proptypes.bool,
  cancelLabel: Proptypes.string,
  applyLabel: Proptypes.string,
  customRangeLabel: Proptypes.string,
  onChange: Proptypes.func,
  onClear: Proptypes.func
}
//************************************//
export default DateRange
